/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { SlaveServerRawConfig } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class SlaveServerService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get slave server protocol configuration (generic)
   *
   * LWM2M path: /1024//92
   *
   * @tapVersion(">=2.1")
   * @return
   */
  getProtocolConfiguration(): Promise<TapResponse<SlaveServerRawConfig>> {
    return this.serviceCallRunner.execute(this.getProtocolConfigurationCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//92
   *
   * @tapVersion(">=2.1")
   * @return call options
   */
  getProtocolConfigurationCall(): ServiceCallType {
    const callOptions = { ...this.resources.getProtocolConfiguration };

    return callOptions;
  }

  /**
   * Set slave server protocol configuration (temporary). Not available anymore.
   *
   * LWM2M path: /1024//92
   *
   * @tapVersion(">=1.0")
   * @param data input
   * @return
   */
  postProtocolConfiguration(
    /*
     *
     */
    data: SlaveServerRawConfig,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.postProtocolConfigurationCall(data),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//92
   *
   * @tapVersion(">=1.0")
   * @param data input
   * @return call options
   */
  postProtocolConfigurationCall(
    /*
     *
     */
    data: SlaveServerRawConfig,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postProtocolConfiguration };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Write slave server protocol configuration
   *
   * LWM2M path: /1024//92
   *
   * @tapVersion(">=2.1")
   * @param data input
   * @return
   */
  putProtocolConfiguration(
    /*
     *
     */
    data: SlaveServerRawConfig,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putProtocolConfigurationCall(data),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//92
   *
   * @tapVersion(">=2.1")
   * @param data input
   * @return call options
   */
  putProtocolConfigurationCall(
    /*
     *
     */
    data: SlaveServerRawConfig,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putProtocolConfiguration };

    callOptions.body = data;

    return callOptions;
  }
}
